module.exports = __webpack_public_path__ + "img/inspiration_styles.1ceac4e.jpg";